export default {

  name: 'HelperService',

  booleanText(value) {
    return value ? 'ja' : 'nein';
  },
}
